import * as React from 'react'

import Box from '@mui/material/Box'
import { LottieComponentProps, LottieRef } from 'lottie-react'

import Button from 'lib/Button'

const lottieData: {
  json: LottieComponentProps['animationData']
  Lottie: React.FC<LottieComponentProps> | null
  fetching: boolean
} = {
  json: undefined,
  fetching: false,
  Lottie: null,
}

export const ErrorPage = () => {
  const [element, setElement] = React.useState(<></>)
  const [count, setCount] = React.useState(5)
  const [render, forceRender] = React.useState(0)
  const timeoutRef = React.useRef<ReturnType<typeof setTimeout> | null>(null)
  const lottieRef: LottieRef = React.useRef(null)
  const path = '/app'

  React.useEffect(() => {
    if (lottieData.json == null) {
      // import('lottie/404.json').then((json) => {
      //   lottieData.json = json.default
      //   forceRender(render + 1)
      // })
    }

    if (lottieData.Lottie == null) {
      import('lottie-react').then((m) => {
        lottieData.Lottie = m.default
        forceRender(render + 1)
      })
    }
  }, [lottieData.json, lottieData.Lottie, render, forceRender])

  React.useEffect(() => {
    if (lottieData.Lottie == null || lottieData.json == null) {
      return
    }

    setElement(
      <lottieData.Lottie
        style={{ height: 400, width: 400 }}
        animationData={lottieData.json}
        loop
        lottieRef={lottieRef}
      />,
    )
  }, [lottieData.Lottie, lottieData.json])

  React.useEffect(() => {
    setTimeout(() => {
      if (count === 1) {
        window.location.assign('/')
      } else {
        setCount(count - 1)
      }
    }, 1000)
    return () => {
      if (timeoutRef.current !== null) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [count, setCount])

  React.useEffect(() => {
    lottieRef.current?.play()
  })

  return (
    <Box
      position='absolute'
      width='100vw'
      height='100vh'
      display='flex'
      justifyContent='center'
      alignItems='center'
    >
      {element != null && (
        <Box>
          {element}
          <Box display='flex' alignItems='center' justifyContent='center'>
            <Box mr={10}>
              <Button size='large' variant='contained' to={path}>
                Redirecting in {count} ...
              </Button>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  )
}
